module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-01.5c570125.svg";